import type { ReactNode } from 'react';
import { Link } from '~/components/Link';
import type { LinkProps } from '~/components/Link/src/Link.types';

type RichLinkProps = Omit<Extract<LinkProps, { asButton?: undefined }>, 'children'> & {
  [dataAttribute: `data-${string}`]: string;
};

export const richLink =
  (props: RichLinkProps) =>
  (chunks: ReactNode): ReactNode => <Link {...props}>{chunks}</Link>;
